import { Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { EntDepartment } from "../../../../models/handBooks/department";
import SelectGovernment from "../../../../components/selects/SelectGovernment";
import i18n from "i18next";

enum FormField {
    nameKy,
    nameRu,
    governmentId
}

interface IProps {
    show: boolean;
    department: EntDepartment;
    onHide: () => void;
    onSubmit: (pos: EntDepartment) => Promise<boolean>;
}

export const AddDepartmentModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);

    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.nameKy, value: props.department.nameKy },
            { name: FormField.nameRu, value: props.department.nameRu },
            { name: FormField.governmentId, value: props.department.government?.id }
        ]);
    }

    const setEntityFromFields = (): EntDepartment => {
        let res = _.cloneDeep(props.department);
        res.nameKy = form.getFieldValue(FormField.nameKy);
        res.nameRu = form.getFieldValue(FormField.nameRu);
        res.governmentId = form.getFieldValue(FormField.governmentId);
        return res;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);
            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={ props.department.id === null ? t('handbooks.departments.add_department') : t('handbooks.departments.edit_department') }
                visible={ props.show }
                onCancel={ props.onHide }
                onSubmit={ handleSubmit }
                submitLoading={ loading }
            >
                <Form
                    initialValues={ { remember: true } }
                    autoComplete="off"
                    layout="vertical"
                    form={ form }
                >
                    <Form.Item
                        label={ t('general.nameKy') }
                        name={ FormField.nameKy }
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off"/>
                    </Form.Item>
                    <Form.Item
                        label={ t('general.nameRu') }
                        name={ FormField.nameRu }
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off"/>
                    </Form.Item>
                    <Form.Item
                        label={ t('titles.governments') }
                        name={ FormField.governmentId }
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <SelectGovernment/>
                    </Form.Item>
                </Form>
            </DraggableModal>
        </>
    )
}
